import ListFilters from "@/common/components/ListFilters";
import { unitTranslation } from "@/common/constants/unitStrategies.contants";
import { strategyToOptions } from "@/common/utils/strategyToOptions";
import { dashboardFilters } from "@/features/company/constants/dashboards/dashboardFilters.constant";
import { DashboardFilterProps, DashboardFilters } from "@/features/company/types/dashboards/dashboard.type";

const unitForConsumptionOptions = strategyToOptions(unitTranslation);

const DashboardFilterEquipmentCategoryUnitForConsumptionBadge = ({ filters, setFilters }: DashboardFilterProps) => {
  return (
    <ListFilters
      filters={[
        {
          className: 'bg-blue-200/20 rounded-xl shadow-none max-w-[200px] text-nowrap',
          placeholder: dashboardFilters[DashboardFilters.EquipmentCategoryUnitForConsumption],
          options: [{ label: 'Todas', value: '' }, ...unitForConsumptionOptions],
          value: filters[DashboardFilters.EquipmentCategoryUnitForConsumption],
          onChange: (e: any) => setFilters((prev) => ({ ...prev, [DashboardFilters.EquipmentCategoryUnitForConsumption]: e?.value ? e : null })),
        }
      ]}
    />
  );
}

export default DashboardFilterEquipmentCategoryUnitForConsumptionBadge;
